import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: theme.spacings.xs,
    right: theme.spacings.xs,
    width: 80,
    aspectRatio: 1,
    borderRadius: theme.borderRadii.full,
    justifyContent: 'center',
    alignItems: 'center',
  },
  correctBg: {
    backgroundColor: theme.colors.primary,
  },
  wrongBg: {
    backgroundColor: theme.colors.red,
  },
});
